import {StyleSheet} from 'react-native';
import {Colors} from '../../../../../constants/Colors';

export const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  icon: {
    marginRight: 10,
  },
  title: {
    fontSize: 12,
    lineHeight: 14,
    color: Colors.GrayPallete.lightgrayThree,
    fontFamily: 'TCCC-UnityHeadline Regular',
  },
});
